var keys = Object.keys,
    getOwnPropertySymbols = Object.getOwnPropertySymbols;
export var getKeysAndSymbols = function getKeysAndSymbols(obj) {
  var result = keys(obj);

  if (getOwnPropertySymbols !== undefined) {
    result = result.concat(getOwnPropertySymbols(obj));
  }

  return result;
};
export default getKeysAndSymbols;